// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * Type of location
 */
export enum ECpmCLocationTypeApiEnum {
    REGION = 'REGION',
    SITE = 'SITE',
    BUILDING = 'BUILDING',
    FLOOR = 'FLOOR',
    ROOM = 'ROOM',
    RACK = 'RACK'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCLocationTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCLocationTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCLocationTypeApiEnum
        ])
);


// ===============================================================
// ===============================================================

/**
 * Type of vector, depending of the location type and vector index
 */
export enum ECpmCLocationVectorTypeApiEnum {
    NONE = 'NONE',
    POS_TOP_DOWN = 'POS_TOP_DOWN',
    POS_3D = 'POS_3D',
    SIZE_3D = 'SIZE_3D',
    GPS = 'GPS'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCLocationVectorTypeApiEnum = Object.fromEntries(
    Object.entries(ECpmCLocationVectorTypeApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCLocationVectorTypeApiEnum
        ])
);

